import { render, staticRenderFns } from "./_PaymentType.vue?vue&type=template&id=772af0d2"
import script from "./_PaymentType.vue?vue&type=script&lang=js"
export * from "./_PaymentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports